import { addProcurementItem } from '../State/procurementItems';

export default () => (dispatch, getState) => {
    const state = getState();
    const procurementItems = state.screens.OrderView.procurementItems;

    // Create a new blank procurement item (placeholder, not saved to backend yet)
    const newItem = {
        id: `_new_${Date.now()}_${Math.random().toString(36).slice(2)}`, // temp ID, replaced after save
        supplier_name: '',
        supplier_item_id: null,
        item_name: '',
        description: '',
        item_code: '',
        unit_of_measure: 'Item',
        quantity: 1,
        unit_cost: 0,
        currency: 'GBP',
        tax_rate: 20,
        markup_percentage: 0,
        lead_time_days: 0,
        required_by_date: null,
        notes: '',
        status: 'pending',
        is_ad_hoc: true,
        total_cost: 0,
        total_sell_price: 0,
        line_order: procurementItems.length,
    };

    dispatch(addProcurementItem(newItem));
}
